module.exports = __webpack_public_path__ + "img/smallplantillas.73c30b82.jpg";